<template>
    <div>
        <div v-if="invoice_id && Object.keys(invoice).length > 0">
            <NewSale :viewdata="invoice" />
        </div>

        <div v-else>
            <b-alert show>NO INVOICE TO LOAD</b-alert>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    // import global_vars from '@/utilities/global_vars'
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'
    import NewSale from "@/components/Sales/NewSale"

    export default {
        name: "EditInvoiceWrapper",
        props: ["viewdata"],
        components: {NewSale},
        data: function(){
            return {
                invoice_id: null,
                invoice: {},
            }
        },
        methods: {
            fetch_init: function(e){
                if (e){
                    e.preventDefault()
                }
                let path = "/api/sales/load_existing_invoice_for_edit/"
                let data = {invoice_id: this.invoice_id}
                let that = this;
                let s = function(response){
                    if (response.data.result){
                        that.invoice = response.data.result;
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.invoice_being_loaded = false;
                }
                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "Error loading invoice. Please try again later.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.invoice_being_loaded = false;
                }
                this.invoice_being_loaded=true;
                Requestor.getAsyncP(path, data, this, s, f);
            }
        },
        created: function(){
            //this.invoice_id = this.$route.query.invoice_id;
            this.invoice_id = this.viewdata.invoice_id;
            //console.log(this.$route.query.invoice_id)
            this.fetch_init()
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Sales/EditInvoiceWrapper.vue